import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class SSOUtilities  {
    _originalTypeClassName = "zERP.BO.SSOUtilities";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
SSOUtilities.translate = translateService;
}
this.SSOUtilitiesKey = null;
this._key = this.SSOUtilitiesKey = 0; 
}

static translate: TranslateService;
_key: any;
private _SSOUtilitiesKey:any;
get SSOUtilitiesKey(): any {
    return this._SSOUtilitiesKey;
  }
set SSOUtilitiesKey(value: any) {
    this._SSOUtilitiesKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.SSOUtilitiesKey == null || $this.SSOUtilitiesKey == 0;
            }


}